import { CheckoutInput } from "../../../../api/backend/backend-api"
import { ProductVariant } from "../../../../types/product"
import { BasketItem } from "../checkoutTypes"
import { basketUpdate } from "./basketUpdate"

const transform = (
  input: ChangeVariantInput,
  checkout: CheckoutInput
): CheckoutInput => {
  const variantsToChange = checkout.lineItems.filter(
    (x) => x.variantId === input.item.variant?.info.variantId
  )
  variantsToChange.forEach((x) => {
    x.variantId = input.newVariant.info.variantId
  })
  return checkout
}

export interface ChangeVariantInput {
  item: BasketItem
  newVariant: ProductVariant
}

export const changeVariant = (
  input: ChangeVariantInput,
  callback?: () => void,
  errorCallback?: (error: any) => void
) => {
  return basketUpdate({
    input: (checkout) => transform(input, checkout),
    callback,
    errorCallback,
  })
}
